<app-modal-wrapper
  [title]="editingId ? 'Edit Integration System' : 'New Integration System'"
  [isDirty]="form.dirty"
  [formValid]="form.valid"
  [loading]="initialLoading"
  [showSaveButton]="true"
  [saveLoading]="saving"
  [keepEditingLabel]="editingId ? 'Keep editing' : 'Keep creating'"
  (save)="save()"
  (closeRequest)="ref.close()"
>
  <div modalSkeleton class="flex flex-col gap-6">
    <div class="flex flex-col gap-1" *ngFor="let i of [1, 2, 3]">
      <p-skeleton width="5rem" height="0.7rem"></p-skeleton>
      <p-skeleton width="100%" height="2.5rem" borderRadius="6px"></p-skeleton>
    </div>
    <p-skeleton width="100%" height="7rem" borderRadius="6px"></p-skeleton>
  </div>

  <form [formGroup]="form" class="flex flex-col gap-6">
    <app-input-dropdown
      label="Tenant"
      [options]="tenants"
      optionLabel="name"
      optionValue="id"
      placeholder="Select a tenant..."
      formControlName="tenantId"
      [required]="!editingId"
    ></app-input-dropdown>

    <app-input-text
      label="Code"
      formControlName="code"
      placeholder="finpac_middleware"
      [required]="true"
    ></app-input-text>

    <app-input-text
      label="Name"
      formControlName="name"
      placeholder="Finpac Middleware"
      [required]="true"
    ></app-input-text>

    <div class="flex flex-col gap-1">
      <label class="font-bold text-gray-700 text-xs uppercase tracking-wide">
        Config JSON
      </label>
      <textarea
        formControlName="configJson"
        rows="5"
        class="rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 outline-none focus:border-[var(--primary-500)] focus:ring-1 focus:ring-[var(--primary-500)] resize-none"
        placeholder='{"baseUrl":"https://..."}'
      ></textarea>
    </div>

    <div
      class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
      (click)="enabledCheck.click()"
    >
      <div class="relative flex items-center justify-center w-5 h-5">
        <input
          #enabledCheck
          type="checkbox"
          formControlName="enabled"
          class="peer appearance-none w-5 h-5 border border-gray-300 rounded bg-white checked:bg-[var(--primary-500)] checked:border-[var(--primary-500)] focus:ring-0 transition-all cursor-pointer"
          (click)="$event.stopPropagation()"
        />
        <i class="pi pi-check absolute text-white text-[10px] font-bold opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity duration-200"></i>
      </div>
      <label class="font-bold text-gray-700 text-sm select-none cursor-pointer">Enabled</label>
    </div>
  </form>
</app-modal-wrapper>
